var map = {
	"./en/autoComplete.json": 39914,
	"./es/autoComplete.json": 95711,
	"./fr/autoComplete.json": 86506,
	"./it/autoComplete.json": 45672,
	"./pt-BR/autoComplete.json": 19981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42095;